import concurnas from "refractor/concurnas";
export default concurnas;